<template>
    <h3>TOTAL {{total}}€</h3>
</template>

<script>
export default {
    computed: {
        total (){
            return this.$store.getters.getAmountTotal;
        }
    }
}
</script>

<style scoped>
h3 {
  text-align: right;
  font-size: 1.5rem;
}
</style>

